export enum Routes {
  HOME = '/',
  SOLUTION = '/solution',
  TEAM = '/team',
  CONTACT = '/contact',
}
